var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.78 4.53C13.6 4.19 14.18 3.34 14.18 2.34C14.18 1.04 13.2 0 12 0C10.79 0 9.81 1.04 9.81 2.34C9.81 3.34 10.39 4.19 11.21 4.53L11.21 6.37L10.24 6.37C9.71 6.37 9.28 6.83 9.28 7.4C9.28 7.43 9.28 7.46 9.28 7.5L3.5 7.5C1.56 7.5 0 9.17 0 11.25L0 30L3.41 27.61C3.98 27.21 4.65 27 5.33 27L20.49 27C22.43 27 24 25.32 24 23.25L24 18.75L20.84 18.75L20.84 22.31C20.84 23.14 20.21 23.81 19.44 23.81L4.55 23.81C3.78 23.81 3.15 23.14 3.15 22.31L3.15 12.18C3.15 11.35 3.78 10.68 4.55 10.68L19.44 10.68C20.21 10.68 20.84 11.35 20.84 12.18L20.84 15.75L24 15.75L24 11.25C24 9.17 22.43 7.5 20.49 7.5L14.71 7.5C14.71 7.46 14.71 7.43 14.71 7.4C14.71 6.83 14.28 6.37 13.75 6.37L12.78 6.37L12.78 4.53ZM8.14 19.12C9.35 19.12 10.33 18.07 10.33 16.78C10.33 15.48 9.35 14.43 8.14 14.43C6.93 14.43 5.95 15.48 5.95 16.78C5.95 18.07 6.93 19.12 8.14 19.12ZM18.04 16.78C18.04 18.07 17.06 19.12 15.85 19.12C14.64 19.12 13.66 18.07 13.66 16.78C13.66 15.48 14.64 14.43 15.85 14.43C17.06 14.43 18.04 15.48 18.04 16.78Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.32c37bd82e3512157fff4a414039571b.svg";
export { ForwardRef as ReactComponent };